export const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

export const maxDecimalFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumSignificantDigits: 1,
});

const priceFormatter = (price: number) => {
    return price < 0.1 && price > -0.1 ? maxDecimalFormatter.format(price) : currencyFormatter.format(price);
};

export { priceFormatter };
